import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../../auth/services/auth.service';
import { ShopService } from '../../../configuration/services/shop.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-home-labeledproduct',
  templateUrl: './home-labeledproduct.component.html',
  styleUrls: ['./home-labeledproduct.component.css','../../../app.component.css'],
  providers: [AuthService,ShopService]
})
export class HomeLabeledProductComponent implements OnInit {
  shops:any = [];
  shopLoaded:boolean = false;
  constructor(private authService: AuthService, private router: Router, private shopService:ShopService) { }
  role:number = 3;
  ngOnInit() {
    try{
      this.role = JSON.parse(localStorage.getItem('user')).role;  
    }catch(e){
    }
    if (localStorage.getItem('shop') != null){
      this.shopLoaded = true;
    }
    this.isLoggedIn();
    this.getShops();
  }

  getShops(){
    this.shopService.query({})
      .subscribe((shops) => {
        this.shops = shops;
      });
  }

  isLoggedIn(){
    this.authService.isLoggedIn().subscribe((response)=>{
      if(!response.isLoggedIn){
        this.router.navigate(['/login']);
      }
    })
  }

  selectShop(id){
    localStorage.setItem('shop',id);
    this.shopLoaded = true;
  }

}



// WEBPACK FOOTER //
// ./src/app/labeledproducts/components/home-labeledproduct/home-labeledproduct.component.ts